export const setProfiles = {
  SET_PROFILES(state, payload) {
    state.profiles = payload
  }
}
